/**
 * First-upload consent (one-time) — persisted in localStorage.
 */
const KEY = "kyp_upload_consent_v1";

export function hasUploadConsent() {
  try {
    return localStorage.getItem(KEY) === "true";
  } catch (e) {
    return false;
  }
}

export function recordUploadConsent() {
  try {
    localStorage.setItem(KEY, "true");
  } catch (e) {}
}

export function clearUploadConsent() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
}
